module.exports = __webpack_public_path__ + "img/sound.984b5901.svg";